import { BulbFilled, BulbOutlined, SettingOutlined } from "@ant-design/icons";
import { Radio, Segmented, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useThemeStore } from "../stores";
import type { ThemeMode } from "../stores/ui/themeStore";

export const ThemeSwitcher = () => {
  const { mode, preset, setMode, setPreset } = useThemeStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Space direction="vertical" size="small">
      <Segmented
        value={mode}
        onChange={(value) => setMode(value as ThemeMode)}
        options={[
          {
            value: "light",
            icon: <BulbOutlined />,
            label: "Light",
          },
          {
            value: "dark",
            icon: <BulbFilled />,
            label: "Dark",
          },
          {
            value: "system",
            icon: <SettingOutlined />,
            label: "System",
          },
        ]}
      />
      <Radio.Group
        value={preset}
        onChange={(e) => setPreset(e.target.value)}
        buttonStyle="solid"
        size="small"
      >
        <Tooltip title="Default Theme">
          <Radio.Button value="default">
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#667FFF",
                display: "inline-block",
              }}
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title="Blue Theme">
          <Radio.Button value="blue">
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#1677ff",
                display: "inline-block",
              }}
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title="Green Theme">
          <Radio.Button value="green">
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#52c41a",
                display: "inline-block",
              }}
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title="Purple Theme">
          <Radio.Button value="purple">
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#722ed1",
                display: "inline-block",
              }}
            />
          </Radio.Button>
        </Tooltip>
      </Radio.Group>
    </Space>
  );
};

export default ThemeSwitcher;
